import { get, post } from '../utilities/api'

export const getForm = id => get({
  url: `/forms/${id}`
})

export const postFormPost = (id, data) => post({
  url: `/forms/${id}/posts`,
  data
})
